import { SOCIAL_PLATFORM_META, SocialPlatformIcon } from "@/components/social-platform-icon";
import { cn } from "@/lib/utils";
import type { SocialPlatform } from "@garimpa/lib/musicTypes";

interface SocialLinksProps {
  links: ReadonlyArray<{ platform: SocialPlatform; url: string }>;
  className?: string;
}

export function SocialLinks({ links, className }: SocialLinksProps) {
  if (links.length === 0) return null;

  return (
    <div className={cn("flex items-center gap-1 my-2", className)}>
      {links.map(({ platform, url }) => {
        const { label } = SOCIAL_PLATFORM_META[platform];
        return (
          <a
            key={platform}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title={label}
            className="relative after:absolute after:-inset-2 after:content-[''] p-1.5 rounded-full bg-black/40 backdrop-blur-sm transition-opacity opacity-90 hover:opacity-100"
          >
            <SocialPlatformIcon platform={platform} label={label} />
          </a>
        );
      })}
    </div>
  );
}
